import React from 'react';
import { Navigate } from 'react-router-dom';

// A utility to check if a token exists
const isAuthenticated = () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  return !!token; // Check if the token exists
};

// A utility to check if the token is expired (optional)
const isTokenExpired = (token) => {
  if (!token) return true;
  const tokenPayload = JSON.parse(atob(token.split('.')[1]));
  return tokenPayload.exp * 1000 < Date.now();  // Compare expiration time with current time
};

// ProtectedRoute component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');

  // If not authenticated or the token is expired, redirect to login page
  if (!isAuthenticated() || isTokenExpired(token)) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
